import { formatMoney } from 'accounting';
export var convertedPrice = function convertedPrice(_ref, value) {
  var exchangeRate = _ref.exchangeRate;
  var convert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return convert ? parseFloat(value * exchangeRate) : parseFloat(value);
};
export var price = function price(_ref2, value) {
  var sign = _ref2.sign,
    exchangeRate = _ref2.exchangeRate,
    numDecimals = _ref2.numDecimals;
  var displaySign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var showTrailingZeroes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var europeanStyleCurrency = ['R$', '€'].indexOf(sign) !== -1;
  var precision = getPrecision(convertedPrice({
    exchangeRate: exchangeRate
  }, value, convert), numDecimals, showTrailingZeroes);
  return formatMoney(convertedPrice({
    exchangeRate: exchangeRate
  }, value, convert), {
    symbol: displaySign ? sign : '',
    thousand: europeanStyleCurrency ? '.' : ',',
    decimal: europeanStyleCurrency ? ',' : '.',
    precision: precision
  });
};
var getPrecision = function getPrecision(convertedPrice, numDecimals, showTrailingZeroes) {
  if (showTrailingZeroes) {
    return numDecimals;
  }
  return convertedPrice % 1 === 0 ? 0 : numDecimals;
};